var React = require('react');

function SocialIconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.95 3.05H12V0H9.575C6.65 0.125 6.05 1.775 6 3.5V5.025H4V8H6V16H9V8H11.475L11.95 5.025H9V4.1C8.99198 3.96835 9.01033 3.83643 9.05397 3.71196C9.09762 3.5875 9.16569 3.47301 9.25417 3.37521C9.34266 3.2774 9.44979 3.19826 9.56928 3.14241C9.68877 3.08657 9.81821 3.05515 9.95 3.05Z","fill":"white"}));
}

SocialIconFacebook.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SocialIconFacebook;

SocialIconFacebook.default = SocialIconFacebook;
